import { useContext, useState } from 'react';
import { useHeightContainer } from 'components/Dashboard/utilities/useHeightContainer';
import { store } from 'components/Store';
import { useContentResults } from 'components/Dashboard/ContentResultsContext';
import { AddToGroupModal } from 'components/Dashboard/Influence/CrmGroups/AddContactsToGroup';
import { Link } from 'react-router-dom';
import { NotesLoadingState } from 'components/Dashboard/StakeHolders/StakeholderPage/ui/BioSections/Notes';

const Groups = (props) => {
  const globalState = useContext(store);
  const { dispatch } = globalState;
  const { contentResults, setContentResults } = useContentResults();

  const { StakeholderInformation, customContact } = props;
  const { groups } = StakeholderInformation;
  const [heightContainer, containerRef] = useHeightContainer();
  const isLoading = false;
  const [isOpen, setIsOpen] = useState(false);
  const personWord = customContact ? 'contact' : 'stakeholder';

  const setStakeholderInformation = ({ newStakeholder }) => {
    if (customContact) {
      dispatch({ type: 'MODIFY_SECTION', parameter: 'customContactInfo', value: newStakeholder });
    } else {
      setContentResults({
        ...contentResults,
        Stakeholders: {
          ...contentResults?.Stakeholders,
          contact: newStakeholder,
        },
      });
    }
  };

  return (
    <>
      <div className='border-bottom'>
        <div className='px-4 specific-bottom-padding-31 specific-top-padding-7 d-flex align-items-center justify-content-between'>
          <button
            className='text-left action-state-hover general-button specific-y-padding-6 pr-3 specific-left-padding-10 text-light-blue border-general border-light-blue rounded-pill d-flex align-items-center'
            onClick={() => setIsOpen(true)}
          >
            <span className='icon-team mr-2 title-h4' />
            <span className='mb-0'>Add this {personWord} to group</span>
          </button>
        </div>
        <div className='border-top px-4 pt-3'>
          <div ref={containerRef} className='pb-3' style={{ minHeight: `${heightContainer - 1}px` }}>
            {isLoading ? (
              <NotesLoadingState />
            ) : (
              <>
                {groups?.length > 0 ? (
                  <>
                    {groups?.map((item) => {
                      const { name, id, description } = item;
                      return (
                        <Link
                          key={`group-${id}`}
                          to={`/people/my-groups/${id}`}
                          className='d-flex box-rounded box-shadow-hover px-4 py-3 reset-link text-main-blue reset-link-color mb-3'
                        >
                          <span className='icon-team mt-1' />
                          <div className='flex-grow-1 pl-3'>
                            <h3 className='title-h5 mb-0'>{name}</h3>
                            <p className='mb-0 main-light-text'>{description}</p>
                          </div>
                        </Link>
                      );
                    })}
                  </>
                ) : (
                  <div
                    className='flex-centered justify-content-center text-center'
                    style={{ height: `${heightContainer - 36}px` }}
                  >
                    <p className='main-light-text title-h5-m' style={{ maxWidth: '420px' }}>
                      This {personWord} is not in any groups
                    </p>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      <AddToGroupModal
        setStakeholderInformation={setStakeholderInformation}
        stakeholder={StakeholderInformation}
        openState={{ isOpen, setIsOpen }}
      />
    </>
  );
};

export default Groups;
